module.exports = __webpack_public_path__ + "static/media/up-arrow.613d2243.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/up-arrow.svg
// module id = 662
// module chunks = 0